import { SelectOptions } from '@spo/logic';
import { SpoSegmentationTypesResponse } from '@spo/types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select, { InputActionMeta, SingleValue } from 'react-select';
import {
  useAllSegmentations,
  useUserSegmentationByIds,
} from '../../../hooks/useUserSegmentation';
import { metaActions } from '../../../utils/metaActions';

export interface SegmentationSelectionInputProps {
  segmentationId: number | null;
  setSelectedSegmentationTypeId: (segTypeId: number) => void;
  disabled: boolean;
}

const formatToOptions = (segmentations: SpoSegmentationTypesResponse) => {
  const userSegListOptions: SelectOptions[] = segmentations.map((seg) => ({
    label: `${seg.typeId} - ${seg.englishName}`,
    value: seg.typeId,
    name: `${seg.englishName}`,
  }));
  return userSegListOptions;
};

export const SegmentationSelectionInput = ({
  segmentationId,
  setSelectedSegmentationTypeId,
  disabled,
}: SegmentationSelectionInputProps) => {
  const { t } = useTranslation();
  const [userSegOptions, setUserSegOptions] = useState<SelectOptions[]>([]);
  const [selectedUserSegmentation, setSelectedUserSegmentation] =
    useState<SelectOptions>();
  const [segmentationSearch, setSegmentationSearch] = useState<string>('');

  const { data: wholeSegmentations } = useAllSegmentations(segmentationSearch);
  const { data: userSegmentationById } = useUserSegmentationByIds(
    segmentationId ? [segmentationId] : [],
  );

  const onInputChange = (search: string, actionMeta: InputActionMeta) => {
    if (actionMeta.action === metaActions.inputChange) {
      setSegmentationSearch(search);
    }
  };

  useEffect(() => {
    if (userSegmentationById) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setSelectedUserSegmentation(formatToOptions(userSegmentationById)[0]);
    }
  }, [userSegmentationById, setSelectedSegmentationTypeId]);

  useEffect(() => {
    if (wholeSegmentations && wholeSegmentations.length > 0) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setUserSegOptions(formatToOptions(wholeSegmentations));
    }
  }, [wholeSegmentations]);

  const handleInputChange = (segOption: SingleValue<SelectOptions>) => {
    if (segOption) {
      setSelectedUserSegmentation(segOption);
      setSelectedSegmentationTypeId(segOption?.value);
    }
  };

  return (
    <div
      className="selection-input-space"
      data-testid="archi-seg-selection_input-space"
    >
      <div className="input-label">{t('input.user-segmentation_label')}</div>
      <Select
        aria-label={t('select.user-segmentation_placeholder')}
        placeholder={t('select.user-segmentation_placeholder')}
        value={selectedUserSegmentation}
        onChange={handleInputChange}
        isSearchable
        hideSelectedOptions={false}
        onInputChange={onInputChange}
        options={userSegOptions}
        id="archi-segmentation-selection"
        isDisabled={disabled}
      />
    </div>
  );
};
